import { ICodeInputConfig } from './codeInput.config';
import { translate } from 'angular';
export default function anFn_17822(codeInputConfig: ICodeInputConfig, $translate: translate.ITranslateService) {
  codeInputConfig.defaultSendText = $translate.instant('Js.CodeInput.DefaultSendText');
  codeInputConfig.defaultResendText = $translate.instant('Js.CodeInput.DefaultResendText');
}
anFn_17822.$inject = ["codeInputConfig", "$translate"];
;